import { render, staticRenderFns } from "./Tasas.vue?vue&type=template&id=2cdc3f1d&scoped=true"
import script from "./Tasas.vue?vue&type=script&lang=js"
export * from "./Tasas.vue?vue&type=script&lang=js"
import style0 from "./Tasas.vue?vue&type=style&index=0&id=2cdc3f1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc3f1d",
  null
  
)

export default component.exports